import React from "react";

function Layout({ children }) {
  return (
    <div>
      <div className="wrapper">
          {children}
        <ul className="bg-bubbles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
  );
}
export default Layout;